import script from "./ToolsDoubleVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolsDoubleVerification.vue?vue&type=script&setup=true&lang=js"

import "./ToolsDoubleVerification.vue?vue&type=style&index=0&id=dce08ea4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dce08ea4"]])

export default __exports__